export const getMarketingSectionContent = ({ i18n }) => ({
  /* i18n-next-line only: ["pt-BR"] */
  seeAllBenefits: i18n.gettext('Conocer todos los beneficios'),
  waveImages: {
    desktop: {
      top: 'buyers/marketing/ware-top-marketing-desktop.png',
      bottom: 'buyers/marketing/ware-bottom-marketing-desktop.png',
    },
    mobile: {
      top: 'buyers/marketing/ware-top-marketing-mobile.png',
      bottom: 'buyers/marketing/ware-bottom-marketing-mobile.png',
    },
  },
});
